import { useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import { ChatTeardropText, X } from "@phosphor-icons/react";

const CATEGORIES = ["confusing", "broken", "slow", "missing", "other"];

export const FrictionFeedback = () => {
    const [open, setOpen] = useState(false);
    const [category, setCategory] = useState("confusing");
    const [message, setMessage] = useState("");
    const [busy, setBusy] = useState(false);
    const loc = useLocation();

    const submit = async () => {
        if (message.trim().length < 5) return toast.error("tell us a bit more (5+ chars)");
        setBusy(true);
        try {
            await api.post("/feedback/friction", { page: loc.pathname, category, message: message.trim() });
            toast.success("logged — thanks for making this better");
            setMessage(""); setOpen(false);
        } catch { toast.error("could not send — try again"); }
        setBusy(false);
    };

    return (
        <>
            <button onClick={() => setOpen(true)} data-testid="friction-open-btn"
                    className="inline-flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-widest text-slate-500 hover:text-cyan-300 transition-colors min-h-[44px] sm:min-h-0">
                <ChatTeardropText size={12} weight="duotone" /> report friction
            </button>
            {open && (
                <div className="fixed inset-0 z-[80] flex items-end sm:items-center justify-center p-3" data-testid="friction-dialog">
                    <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={() => setOpen(false)} aria-hidden="true" />
                    <div className="relative w-full max-w-md bg-[#0a0e17] border border-white/10 rounded-md p-5 shadow-2xl shadow-black/60">
                        <button onClick={() => setOpen(false)} aria-label="Close" data-testid="friction-close"
                                className="absolute top-2 right-2 w-11 h-11 inline-flex items-center justify-center text-slate-500 hover:text-slate-300">
                            <X size={14} weight="bold" />
                        </button>
                        <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-cyan-400/80">// report friction</div>
                        <p className="text-xs text-slate-400 mt-1.5">something confusing, broken or missing on <span className="text-slate-200 font-mono">{loc.pathname}</span>? tell us — it goes straight to the build queue.</p>
                        <div className="flex flex-wrap gap-1.5 mt-3.5">
                            {CATEGORIES.map((c) => (
                                <button key={c} onClick={() => setCategory(c)} data-testid={`friction-cat-${c}`}
                                        className={`text-[10px] uppercase tracking-widest font-mono px-3 py-2 min-h-[40px] sm:min-h-0 rounded-sm border transition-colors ${category === c ? "border-cyan-500/60 bg-cyan-500/10 text-cyan-300" : "border-white/10 text-slate-500 hover:text-slate-300"}`}>
                                    {c}
                                </button>
                            ))}
                        </div>
                        <textarea value={message} onChange={(e) => setMessage(e.target.value)} rows={3} maxLength={1000}
                                  placeholder="what happened / what did you expect?"
                                  data-testid="friction-message"
                                  className="mt-3 w-full bg-[#0b0f19] ring-1 ring-white/10 text-slate-200 text-sm rounded-sm p-3 focus:ring-2 focus:ring-cyan-500/50 focus:outline-none" />
                        <button onClick={submit} disabled={busy} data-testid="friction-submit"
                                className="mt-3 w-full bg-cyan-400 hover:bg-cyan-300 text-slate-950 font-bold text-xs uppercase tracking-widest py-3 rounded-sm transition-colors disabled:opacity-50">
                            {busy ? "sending…" : "send it"}
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};
